export default __webpack_public_path__ + "static/media/NL-flag.e88a5563.svg";